export default {
  title: 'Sincronização de marca — Marcas',
  subtitle:
    'Visão geral de todos os restaurantes do grupo e das suas funcionalidades sincronizadas. Só o administrador da conta pode fazer alterações.',
  alert: {
    message: 'Acesso restrito ao administrador',
    description:
      'As alterações ao menu principal, preços e ofertas só podem ser feitas pelo administrador da conta. Todas as localizações recebem atualizações automaticamente.',
  },
  locations: {
    title: 'Localizações',
    description: 'Todos os restaurantes do grupo partilham o menu principal e as definições',
    locations_zero: '0 localizações',
    locations_one: '1 localização',
    locations_other: '{{count}} localizações',
    synced: 'Sincronizado',
  },
  features: {
    title: 'Funcionalidades Sincronizadas',
    description: 'Estas funcionalidades são controladas pelas definições principais',
    menus: {
      title: 'Menu Principal',
      desription: 'Itens de menu, categorias e descrições são sincronizados em todas as localizações',
    },
    smart_pricing: {
      title: 'Preços Inteligentes',
      desription: 'As regras e ajustes de preços são sincronizados em todas as localizações',
    },
    offers: {
      title: 'Ofertas e Promoções',
      desription: 'Ofertas, descontos e promoções ativas são sincronizados em todas as localizações',
    },
  },
};
